import { SvgIconProps } from "@mui/material";
import React, { useMemo } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { Tooltip } from "react-tippy";
import LoadingEllipsis from "../../../../components/Loading/LoadingEllipsis";
import Ratings from "../../../../components/Ratings/Ratings";
import { getGranularityFromDate, isNull } from "../../../../utils/utilityFunctions";

interface Props {
  Icon: React.ComponentType<SvgIconProps>;
  title: string;
  titleSubtext?: string;
  titleTooltipText: string;
  mainValue: number;
  previousValue: number
  yoyValue: number;
  popValue: number;
  isLoading: boolean;
  isPercentage?: boolean;
  isRating?: boolean;
}

const PoPLabelMapping: Record<string, string> = {
  monthly: "MoM",
  quarterly: "QoQ",
};

const MetricTileWithIcon = (props: Props) => {
  const { Icon, title, titleSubtext, titleTooltipText, mainValue, previousValue, yoyValue, popValue, isLoading, isPercentage, isRating } = props;
  const dateRangeParam = useSelector((state: RootStateOrAny) => state.parameters.date_range);

  const PoPLabel = useMemo(() => {
    const dateGranularity = getGranularityFromDate(dateRangeParam, "monthly");
    return PoPLabelMapping[dateGranularity];
  }, [dateRangeParam]);

  const showTitleSubtext = useMemo(() => {
    if (dateRangeParam) {
      const isCustomMonth = dateRangeParam.includes(" - ")
      return dateRangeParam.includes("quarter") || dateRangeParam.includes("financial year") || dateRangeParam.includes("month") || (isCustomMonth && dateRangeParam.split("-")[0].trim() == dateRangeParam.split("-")[1].trim())
    }
    return false
  }, [dateRangeParam])

  return (
    <div className="tile metric-tile">
      <div className="icon">{<Icon fontSize="large" />}</div>
      <div className="tile-content">
        <div className="title-container">
          {title && <div className="title"><div>{title}</div> {titleSubtext && showTitleSubtext && <div className="title-subtext">({titleSubtext})</div>}</div>}
          <Tooltip
            position="top-end"
            className={"normal_tippy"}
            trigger="mouseenter"
            animation="none"
            interactive={true}
            delay={1}
            hideDelay={1}
            duration={1}
            title={titleTooltipText}
            size={"small"}
          >
            <span className="info_tooltip" />
          </Tooltip>
        </div>

        <div className="metrics">
          <div>
            <div>Selected period</div>

            <div className="value">{!isNull(mainValue) && mainValue != undefined ? `${mainValue?.toLocaleString(undefined, isPercentage ? { minimumFractionDigits: 1 } : undefined)}${isPercentage ? "%" : ""}` : "n/a"}</div>

            <div className="variance">
              <div className="yoy-variance">
                <div>
                  <Ratings value={yoyValue} isPercentageValue={false} testValue={false} />
                </div>
                {!isNull(yoyValue) && yoyValue != undefined ? `${yoyValue}${isRating || isPercentage ? " PTS" : "%"} Yoy` : "n/a"}
              </div>
              {!isNull(popValue) && popValue != undefined && (
                <div className="pop-variance">
                  <Ratings value={popValue} isPercentageValue={false} testValue={false} />
                  {popValue}{isRating || isPercentage ? "PTS" : "%"} {PoPLabel}
                </div>
              )}
            </div>
          </div>
          <div>
            <div>Previous period</div>

            <div className="value">{!isNull(previousValue) && previousValue != undefined ? `${previousValue?.toLocaleString(undefined, isPercentage ? { minimumFractionDigits: 1 } : undefined)}${isPercentage ? "%" : ""}` : "n/a"}</div>

          </div>
        </div>

      </div>
      <LoadingEllipsis isLoading={isLoading} />
    </div>
  );
};

export default MetricTileWithIcon;
